import { render, staticRenderFns } from "./Carfax.vue?vue&type=template&id=7c16bfed&"
import script from "./Carfax.vue?vue&type=script&lang=js&"
export * from "./Carfax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports